import dayjs from 'dayjs';
import type DatesService from 'lumen/services/dates';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getEventDateRangeDisplay(
  startDate: string,
  endDate: string,
  datesService: DatesService,
) {
  let fullDate = dayjs(startDate).format(
    datesService.partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_MEDIUM,
  );

  if (endDate !== startDate) {
    fullDate += ` - ${dayjs(endDate).format(
      datesService.partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_MEDIUM,
    )}`;
  }

  return fullDate;
}
